export default __webpack_public_path__ + "static/media/player.5dd24a91.jpg";